import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
// import { styled } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from "@material-ui/icons/Close";
import Typography from '@material-ui/core/Typography';
import { Grid, Box, FormGroup, FormControlLabel, Checkbox } from "@material-ui/core";
import signup from "./SignupDialog";
import thankyou from "./ThankyouDialog";
import useStyles from "./Styles";
import {
    checkEmailValid,
    checkPasswordStrength,
  } from "components/User/Validation";
import { useHistory } from "react-router";
import { USER_SIGNUP_PROP } from "components/User/constants";
import { AppRouteURI } from "router/RoleBasedAccess";
import authActions from "components/Auth/actions";
import { useSelector } from "react-redux";

// const BootstrapDialog = styled(Dialog)(({ theme }) => ({
//   '& .MuiDialogContent-root': {
//     padding: theme.spacing(2),
//   },
//   '& .MuiDialogActions-root': {
//     padding: theme.spacing(1),
//   },
// }));

function BootstrapDialogTitle(props) {
    const classes = useStyles();
    const { children, onClose, ...other } = props;
  
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            className={classes.closeButton}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const confirmationDialog = (handleClose, setScreen, classes, termsChecked, handleTermsCheck) => {
    return (
        <>
            <DialogContent style={{ padding: '0px', overflowX: 'hidden' }}>
                <Typography className={classes.confirmationDialogTitle}>
                    Creating an Account
                </Typography>
            <Typography gutterBottom className={classes.confirmationDialogContent}>
                <p>Thank you for your interest in the Arizona Colorado River Visualization Enterprise (CuRVE).  Before entering, please be aware that the design of the technical CuRVE tool assumes users have a basic understanding of water management issues in Arizona and the Colorado River basin.  If this is not the case for you, please feel free to continue, but pay particular attention to explainers, hover tools, links, labels, and text.  </p>
                
<p>The various legal documents that describe how Colorado River shortages are distributed across entitlement holders span decades, are sometimes vague, and often contradict each other.  This tool presents reasonable estimates of Colorado River shortage impacts for entitlement holders in Arizona based on myriad assumptions. The CuRVE models only wet water delivery obligations.  Paper water transfers of long-term storage credits are not included in the results.
  
</p>
            </Typography>
            <FormGroup className={classes.confirmationDialogContent}>
                <FormControlLabel control={
                        <Checkbox 
                            checked={termsChecked}
                            onChange={handleTermsCheck}
                        />
                    } label="I Understand" 
                />
                </FormGroup>
            </DialogContent>
            <DialogActions className={classes.confirmationDialogActions}>
                <Grid container spacing={8}>
                    <Grid item xs={6} align="right" >
                        <Box>
                            <Button variant="contained" 
                                onClick={() => setScreen({
                                confirmation: false,
                                createAccount: true,
                                thankYou: false
                            })}
                            color="primary"
                            disabled={!termsChecked}
                            >Confirm</Button>
                        </Box>
                    </Grid>
                    <Grid item xs={6} align="left">
                        <Box>
                            <Button variant="outlined" onClick={handleClose}>Cancel</Button>
                        </Box>
                    </Grid>
                </Grid>
            </DialogActions>
        </>
    )
}

export default function CustomizedDialogs({ open,
    handleClose, screen, setScreen, fieldChecked,
    setFieldChecked, termsChecked, setTermsChecked,
    privacyChecked, setPrivacyChecked }) {
    const classes = useStyles();
    const history = useHistory();
    const [isFormValid, setIsFormValid] = useState(true);
    const dialogClose = () => {
        setOpenPrivacy(false);
    };
    const [openPrivacy, setOpenPrivacy] = useState(false);
    const [emailExistsError, setEmailExistsError] = useState(false)

    const handlePrivacyPolicyCheck = () => {
        setPrivacyChecked(!privacyChecked);
    }
    const handleTermsCheck = () => {
        setTermsChecked(!termsChecked);
    }

    useEffect(()=>{
        setEmailExistsError(false)
    },[screen])

    const {
        resendVerification,
        register,
        email_exists,
        processInvite,
        setRegistration: setUser,
        loadInviteDetails,
      } = authActions();
    const { location } = useSelector((state) => state.router);
    const { register: user } = useSelector((state) => state.auth);
    // const classes = useStyles();
    useEffect(() => {
        checkFormValidity();
        });
    const hasToken = !!location.query.token;

    const checkExistingEmail = (email) => {
        email_exists(email, (flag)=>{setEmailExistsError(flag)})
    }

    const submitForm = (event) => {
    event.preventDefault();
        if (!hasToken) {
            register(user);
        } else {
            processInvite(user);
        }
        setScreen({
            confirmation: true,
            createAccount: false,
            thankYou: false
        });
    };
    const textfields = [
    USER_SIGNUP_PROP.EMAIL,
    USER_SIGNUP_PROP.FNAME,
    USER_SIGNUP_PROP.LNAME,
    USER_SIGNUP_PROP.AFFILIATION,
    USER_SIGNUP_PROP.HEARABOUTUS,
    USER_SIGNUP_PROP.PASSWORD,
    USER_SIGNUP_PROP.REPEAT_PASSWORD,
    ];

    const handleResendEmail = () => {
        resendVerification(user[USER_SIGNUP_PROP.EMAIL]);
      }

    const validatePasswords = (password, repeatPassword) => {
        return password === repeatPassword
    }

    const checkFormValidity = () => {
    const checkFields =
        checkEmailValid(user[USER_SIGNUP_PROP.EMAIL]) &&
        !!user[USER_SIGNUP_PROP.FNAME] &&
        !!user[USER_SIGNUP_PROP.AFFILIATION] &&
        !!checkPasswordStrength(user[USER_SIGNUP_PROP.PASSWORD]) &&
        !!user[USER_SIGNUP_PROP.LNAME] &&
        !!validatePasswords(user[USER_SIGNUP_PROP.PASSWORD], user[USER_SIGNUP_PROP.REPEAT_PASSWORD])&&
        !emailExistsError ;
    setIsFormValid(checkFields);
    };
    const checkInviteField = (value) => {
        return (
          hasToken &&
          value === USER_SIGNUP_PROP.EMAIL &&
          user[value] !== "" &&
          user.inviteType === "EMAIL"
        );
      };
    
    useEffect(() => {
        if (location.pathname === AppRouteURI.INVITATION) {
            loadInviteDetails();
        }
    }, [loadInviteDetails, location]);
  return (
    <div>
        <Dialog
            transitionDuration={{ exit: 0, enter: 0 }}
            maxWidth={ screen.thankYou ? 'sm' : 'md' }
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            classes={{ paper: classes.dialogContainer }}
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}></BootstrapDialogTitle>
            {screen.confirmation && confirmationDialog(handleClose, setScreen, classes, termsChecked, handleTermsCheck)}
            {screen.createAccount && signup(handleClose, setScreen, classes, submitForm, textfields, checkInviteField, user, setFieldChecked, fieldChecked, isFormValid,
                setUser, privacyChecked, handlePrivacyPolicyCheck, setOpenPrivacy, dialogClose, openPrivacy, checkExistingEmail, emailExistsError)}
            {screen.thankYou && thankyou(classes, history, handleResendEmail)}
        </Dialog>
    </div>
  );
}
